/**
 * Payment Service
 *
 * Service for payment-related operations including receipt synchronization
 */

import api from "./api";

interface SyncReceiptsResponse {
  success: boolean;
  message: string;
  total_receipts: number;
}

/**
 * Sync payment receipts from Google Drive
 *
 * This function calls the backend to synchronize payment records
 * with receipt URLs from Google Drive folders.
 */
export async function syncDriveReceipts(): Promise<SyncReceiptsResponse> {
  const response = await api.post<SyncReceiptsResponse>(
    "/payments/sync-receipts/",
  );
  return response.data;
}

export const paymentService = {
  syncDriveReceipts,
};
